<template>
  <div id="app">
    <router-view></router-view>
    <el-tooltip placement="top" content="回到顶部">
      <back-to-top
        :custom-style="myBackToTopStyle"
        :visibility-height="300"
        :back-position="0"
        transition-name="fade"
      />
    </el-tooltip>
  </div>
</template>

<script>
import BackToTop from "@/components/backTop/BackToTop"; //返回顶部
export default {
  components: {
    BackToTop,
  },
  data() {
    return {
      myBackToTopStyle: {
        right: "2%",
        bottom: "150px",
        width: "40px",
        height: "40px",
        borderRadius: "4px",
        lineHeight: "45px", // 请保持与高度一致以垂直居中
        background: "#02ADA4", // 按钮的背景颜色
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang='scss'>
@import "assets/css/reset.scss";
</style>


